/**
 * FIREBASE UTILS SIMPLE - Fallback para casos donde el caché falla
 * Funciones básicas de Firebase sin optimizaciones complejas
 */

import { collection, getDocs, query, where, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

// Función simple para obtener certificados sin caché
export const getCertificadosSimple = async (filtros = {}) => {
    try {
        let firebaseQuery = collection(db, 'certificados');
        
        // Aplicar filtros básicos
        if (filtros.usuarioEmail) {
            firebaseQuery = query(firebaseQuery, where('usuarioEmail', '==', filtros.usuarioEmail));
        }
        
        if (filtros.empresa) {
            firebaseQuery = query(firebaseQuery, where('empresa', '==', filtros.empresa));
        }

        // Límite por defecto
        if (!filtros.sinLimite) {
            firebaseQuery = query(firebaseQuery, limit(filtros.limite || 100));
        }

        const snapshot = await getDocs(firebaseQuery);
        const certificados = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        console.log(`✅ Certificados cargados (modo simple): ${certificados.length}`);
        return certificados;

    } catch (error) {
        console.error('❌ Error en getCertificadosSimple:', error);
        throw error;
    }
};

// Función simple para obtener usuarios
export const getUsuariosSimple = async () => {
    try {
        const snapshot = await getDocs(collection(db, 'users'));
        const usuarios = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        console.log(`✅ Usuarios cargados (modo simple): ${usuarios.length}`);
        return usuarios;

    } catch (error) {
        console.error('❌ Error en getUsuariosSimple:', error);
        throw error;
    }
};

// Wrapper que intenta usar caché inteligente pero hace fallback a simple
export const getCertificadosConFallback = async (filtros = {}) => {
    try {
        // Intentar importar el caché inteligente
        const { default: firebaseOptimizado } = await import('./cache-inteligente-chile');
        
        // Si se solicita forceRefresh, limpiar caché primero
        if (filtros.forceRefresh) {
            console.log('🔄 Force refresh solicitado, limpiando caché...');
            firebaseOptimizado.limpiarCache();
        }
        
        return await firebaseOptimizado.getCertificados(filtros);
    } catch (error) {
        console.warn('⚠️ Caché inteligente falló, usando modo simple:', error.message);
        return await getCertificadosSimple(filtros);
    }
};

export const getUsuariosConFallback = async () => {
    try {
        const { default: firebaseOptimizado } = await import('./cache-inteligente-chile');
        return await firebaseOptimizado.getUsuarios();
    } catch (error) {
        console.warn('⚠️ Caché inteligente falló, usando modo simple:', error.message);
        return await getUsuariosSimple();
    }
};

// 🚀 FIREBASE UTILS: Exportar objetos de manera válida
const firebaseUtils = {
    getCertificados: getCertificadosConFallback,
    getUsuarios: getUsuariosConFallback,
    getCertificadosSimple,
    getUsuariosSimple
};

export default firebaseUtils;